<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container style="padding: 24px">
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Galería</h3>
            </v-col>
            <v-col cols="1" md="1" class="close-icon-container">
              <v-icon
                @click="$emit('close-dialog')"
                style="transform: translateX(-15px)"
                >close</v-icon
              >
            </v-col>
          </div>
          <div style="height: 50px"></div>
          <v-row>
            <v-col cols="12" v-for="(gal, i) in gallery" :key="i">
              <v-row style="margin: 0">
                <h4>{{ gal.description }}</h4>
                <v-icon
                  v-if="gal.allow_update"
                  style="margin-left: 12px"
                  @click="showUploader(gal)"
                  >cloud_upload</v-icon
                >
              </v-row>
              <v-row>
                <v-col cols="6" md="4" v-for="(file, j) in gal.files" :key="j">
                  <v-row>
                    <v-col cols="12" style="padding-bottom: 0">
                      <v-img
                        v-if="file.mimetype != 'application/pdf'"
                        :src="getFile(file.file)"
                      />
                      <div v-else class="pdf-preview-container">
                        <iframe
                          :src="getFile(file.file)"
                          class="pdf-preview"
                          style="cursor: zoom-in"
                          ref="pdfprev"
                        >
                        </iframe>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      style="display: flex; justify-content: center"
                    >
                      <v-icon @click="showPreview(file)">visibility</v-icon>
                      <v-icon
                        v-if="file.allow_delete"
                        @click="deleteFile(file)"
                        style="margin-left: 24px"
                        >delete</v-icon
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <input
            ref="imgloader"
            type="file"
            multiple
            name="imagenes"
            @change="
              encode($event.target.files);
              fileCount = $event.target.files.length;
            "
            accept="image/*"
            class="input-file"
          />
          <input
            ref="pdfloader"
            type="file"
            multiple
            name="documentos"
            @change="
              encode($event.target.files);
              fileCount = $event.target.files.length;
            "
            accept="application/pdf"
            class="input-file"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <FilePreview
      v-if="dialogPreview"
      :show="dialogPreview"
      :file="selectedFile"
      :requestId="requestId"
      @close-dialog="closeFilePreviewDialog"
    />
  </section>
</template>
<script>
import FilePreview from "./FilePreview";

export default {
  components: {
    FilePreview,
  },
  props: {
    noAnswer: { type: Boolean, default: false },
    show: Boolean,
    gallery: Array,
    requestId: Number,
  },
  data() {
    return {
      token: null,
      showDialog: false,
      dialogImage: null,
      selectedGallery: null,
      dialogPreview: false,
      selectedFile: {},
    };
  },
  created() {
    this.$emit("reload-request");
    const user = JSON.parse(localStorage.getItem("user"));
    this.token = user.stsTokenManager.accessToken;
  },
  mounted() {
    if (this.noAnswer) {
      this.showUploader(this.gallery[0]);
      this.noAnswer = false;
    }
  },
  methods: {
    getFile(url) {
      return url + "?token=" + this.token;
    },
    showPreview(file) {
      this.selectedFile = file;
      this.dialogPreview = true;
    },
    closeFilePreviewDialog() {
      this.dialogPreview = false;
      this.selectedFile = null
    },
    showUploader(gallery) {
      this.selectedGallery = gallery.name;
      if (gallery.type_file === "image") {
        this.$refs.imgloader.click();
      } else {
        this.$refs.pdfloader.click();
      }
    },
    uploadFile(fileName, file) {
      if (!fileName || !file || !this.selectedGallery || !this.requestId) {
        return;
      }

      const url = `/request/${this.requestId}/gallery/`;

      const imageData = {
        gallery_type: this.selectedGallery,
        file_name: fileName,
        file: file,
      };

      this.axios
        .post(url, imageData)
        .then((response) => {
          this.$emit("reload-request");
          this.clearLoaders();
        })
        .catch((error) => {
          console.error("Error al subir la imagen:", error);
          this.handleUploadError(error);
        });
    },
    clearLoaders() {
      this.$refs.imgloader.value = "";
      this.$refs.pdfloader.value = "";
    },
    handleUploadError(error) {
      // Aquí puedes manejar el error de la forma que necesites,
      // como mostrar un mensaje al usuario.
      alert("Hubo un error al subir la imagen. Por favor, inténtalo de nuevo.");
    },
    encode(files) {
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader();
        fileReader.file_name = file.name;
        fileReader.readAsDataURL(file);
        fileReader.onloadend = () => {
          this.uploadFile(fileReader.file_name, fileReader.result);
        };

        fileReader.onerror = () => {
          console.error(`Error al leer el archivo: ${file.name}`);
        };
      });
    },
    deleteFile(file) {
      const url = `request/${this.requestId}/gallery/${file.id}`;
      this.axios.delete(url).then((response) => {
        this.$emit("reload-request");
      });
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .pdf-preview {
    height: 270px;
    width: 100%;
    border: none;
    margin-top: -56px;
  }
}
@media (min-width: 960px) {
  .pdf-preview {
    height: 640px;
    width: 100%;
    border: none;
    margin-top: -56px;
  }
  .close-icon-container {
    display: flex;
    justify-content: flex-end;
  }
}
.pdf-preview-container {
  height: 100%;
  width: 100%;
  overflow-y: hidden;
}
.input-file {
  display: none;
}
</style>
